import React, { Component } from "react";

interface TempProfileProps {
    profile_id: number;
    fullname: string;
    address: string;
    compensation?: string;
    is_form?: boolean;
    distance?: string;
    availabilityDay?: string;
    availabilityStart?: string;
    availabilityEnd?: string;
    phone?: string | false;
    position_type_tags: string;
    tags_for_profile: string;
    shortened_tags_for_profile: string;
    profile_url: string;
    job_types: string[];
    profile_image: string;
    request_status?: string;
    request_status_readable?: string;
}

interface TempProfileState {
    checked_checkbox: boolean;
    show_more: boolean;
}

class TempProfile extends Component<TempProfileProps, TempProfileState> {
    constructor(props: TempProfileProps) {
        super(props);
        this.state = {
            checked_checkbox: true,
            show_more: false
        };
    }

    toggleCheckbox = () => {
        if (this.props.is_form) {
            this.setState({ checked_checkbox: !this.state.checked_checkbox });
        }
    };

    toggleMore = () => this.setState((state) => ({ show_more: !state.show_more }));

    render() {
        const mapMarker = (
            <span>
                <i className="fa fa-map-marker"></i> {this.props.address}
            </span>
        );

        let moneyIcon: JSX.Element | null = null;
        if (this.props.compensation) {
            moneyIcon = (
                <span>
                    <i className="fa fa-money"></i> {this.props.compensation}
                </span>
            );
        }

        let checkbox: JSX.Element | null = null;
        if (this.props.is_form) {
            checkbox = (
                <label className="checkbox-container">
                    <input 
                        type="checkbox"
                        name="temp_requests[]"
                        id="temp_requests_"
                        value={this.props.profile_id}
                        checked={this.state.checked_checkbox}
                        readOnly={true} 
                    />
                    <span className="checkmark" onClick={this.toggleCheckbox}></span>
                </label>
            );
        }

        let distance: JSX.Element | null = null;
        if (this.props.distance) {
            distance = (
                <span>
                    <i className="fa fa-car"></i>
                    {this.props.distance}
                </span>
            );
        }

        let availability: JSX.Element | null = null;
        if (this.props.availabilityDay) {
            availability = (
                <span>
                    <i className="fa fa-clock-o"></i>
                    <strong>{this.props.availabilityDay}</strong>: {this.props.availabilityStart} to {this.props.availabilityEnd}
                </span>
            );
        }

        let phone: JSX.Element;
        if (this.props.phone === "undefined" || this.props.phone === false) {
            phone = <strong></strong>;
        } else {
            phone = <span><i className="fa fa-phone"></i> {this.props.phone}</span>;
        }

        let jobListContent: JSX.Element;

        if (this.state.show_more === true) {
            jobListContent = (
                <div className="job-list-content">
                    <h4 className="fullnamer">
                        {this.props.fullname}
                        <a 
                            className="button temp_profile"
                            target="_blank"
                            href={`/profiles/${this.props.profile_id}`}
                            rel="noopener noreferrer"
                        >
                            View Profile
                        </a>
                    </h4>

                    <div className="job-icons">
                        {availability}
                    </div>
                    <br />

                    <div className="job-icons">
                        {mapMarker}
                        {distance}
                        {moneyIcon}
                        {phone}
                    </div>

                    <h4 
                        className="tags-no-padding" 
                        dangerouslySetInnerHTML={{ __html: this.props.position_type_tags + this.props.tags_for_profile }}
                    />
                </div>
            );
        } else {
            jobListContent = (
                <div className="job-list-content">
                    <h4 className="fullnamer">
                        {this.props.fullname}
                        <a 
                            className="button temp_profile"
                            target="_blank"
                            href={this.props.profile_url}
                            rel="noopener noreferrer"
                        >
                            View Profile
                        </a>
                    </h4>

                    <div className="job-icons">
                        {availability}
                        {this.props.job_types.map((jt, index) => (
                            <span key={index}>
                                <i className="fa fa-tooth"></i>{jt}
                            </span>
                        ))}
                    </div>
                    <br />

                    <div className="job-icons">
                        {mapMarker}
                        {distance}
                        {moneyIcon}
                        {phone}
                    </div>

                    <h4 
                        className="tags-no-padding" 
                        dangerouslySetInnerHTML={{ __html: this.props.position_type_tags + this.props.shortened_tags_for_profile }}
                    />
                </div>
            );
        }

        let request_status: JSX.Element;
        if (this.props.request_status === "") {
            request_status = <div></div>;
        } else {
            request_status = (
                <a 
                    className={`button gray pull-right ${this.props.request_status}`} 
                    style={{ width: 'auto', textAlign: 'right' }}
                >
                    {this.props.request_status_readable}
                </a>
            );
        }

        const profile = (
            <div className="field temp_profile">
                <li>
                    {checkbox}
                    <a>
                        <img 
                            className="pull-left" 
                            style={{ marginRight: 20 }} 
                            src={this.props.profile_image} 
                            alt="" 
                        />
                        {jobListContent}
                        {request_status}
                    </a>
                    <div className="clearfix"></div>
                </li>
            </div>
        );

        return <>{profile}</>;
    }
}

export default TempProfile;
